<template>
  <v-footer padless id="kontakt">
    <v-container>
      <v-row>
        <v-col>
          <v-card flat>
            <v-card-title class="justify-center">Kontakt</v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="(item, i) in companyInfo" :key="i">
          <v-list>
            <v-subheader class="justify-center">{{ item.name }}</v-subheader>

            <v-list-item @click="copyText(item.text)" link>
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="index" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list></v-col
        >
      </v-row>
      <v-row>
        <v-col>
          <v-list>
            <v-subheader class="justify-center"
              >Dział handlowy — Paweł Pękul</v-subheader
            >

            <v-list-item
              v-for="(contact, i) in contacts.dzaial_handlowy"
              :key="i"
              :href="
                !isMobile
                  ? ''
                  : contact.type == 'mail'
                  ? `mailto:${contact.text}`
                  : `tel:${contact.text}`
              "
              @click="copyText(contact.text)"
            >
              <v-list-item-icon>
                <v-icon v-text="contact.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="index" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title
                      v-text="contact.text"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col>
          <v-list>
            <v-subheader class="justify-center">Biuro</v-subheader>
            <v-list-item
              v-for="(contact, i) in contacts.biuro"
              :key="i"
              :href="
                !isMobile
                  ? ''
                  : contact.type == 'mail'
                  ? `mailto:${contact.text}`
                  : `tel:${contact.text}`
              "
              @click="copyText(contact.text)"
            >
              <v-list-item-icon>
                <v-icon v-text="contact.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="index" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title
                      v-text="contact.text"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col>
          <v-list>
            <v-subheader class="justify-center"
              >Dział techniczny — Kamil Szydlik</v-subheader
            >
            <v-list-item
              v-for="(contact, i) in contacts.dzaial_techniczny"
              :key="i"
              :href="
                !isMobile
                  ? ''
                  : contact.type == 'mail'
                  ? `mailto:${contact.text}`
                  : `tel:${contact.text}`
              "
              @click="copyText(contact.text)"
            >
              <v-list-item-icon>
                <v-icon v-text="contact.icon"></v-icon>
              </v-list-item-icon>
              <v-tooltip right nudge-left="100" :key="index" color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content v-bind="attrs" v-on="on">
                    <v-list-item-title
                      v-text="contact.text"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>Skopiuj</span>
              </v-tooltip>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
    <div id="my_div" class="designed">
      — Created by <strong>CoreStudio</strong> —
    </div>
    <v-snackbar color="success" v-model="snackbar" :timeout="3000">
      <v-icon class="mr-2">mdi-check</v-icon>
      Wartość <strong>{{ copyValue }}</strong> została zapisana w schowku!

      <template v-slot:action="{ attrs }">
        <v-btn
          small
          elevation="0"
          fab
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      copyValue: "",
      snackbar: false,
      contacts: {
        biuro: [
          {
            text: "biuro@jkpelektromontaz.pl",
            icon: "mdi-email",
            type: "mail",
          },
        ],
        dzaial_handlowy: [
          {
            text: "pawel.pekul@jkpelektromontaz.pl",
            icon: "mdi-email",
            type: "mail",
          },
          {
            text: "501 765 882",
            icon: "mdi-phone",
            type: "phone",
          },
        ],
        dzaial_techniczny: [
          {
            text: "kamil.szydlik@jkpelektromontaz.pl",
            icon: "mdi-email",
            type: "mail",
          },
          {
            text: "506 972 803",
            icon: "mdi-phone",
            type: "phone",
          },
        ],
      },
      companyInfo: [
        {
          name: "Pełna nazwa",
          text: "JKP Elektromontaz Kamil Szydlik Spółka Jawna",
          icon: "mdi-office-building",
        },
        {
          name: "NIP",
          text: "7622007180",
          icon: "mdi-clipboard-text",
        },
        {
          name: "Regon",
          text: "382469815",
          icon: "mdi-clipboard-text",
        },
      ],
    };
  },
  methods: {
    copyText(textToCopy) {
      const tmpTextField = document.createElement("textarea");
      tmpTextField.textContent = textToCopy;
      tmpTextField.setAttribute("style", "position:absolute; right:200%;");
      document.body.appendChild(tmpTextField);
      tmpTextField.select();
      tmpTextField.setSelectionRange(0, 99999); /*For mobile devices*/
      document.execCommand("copy");
      tmpTextField.remove();
      this.copyValue = textToCopy;
      this.snackbar = true;
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
};
</script>

<style lang="scss">
.designed {
  background: #000;
  color: #fff;
  font-size: 0.8rem;
  flex: 0 0 100%;
  padding: 5px 0;
  text-align: center;
}
</style>
